/* eslint-disable react-hooks/exhaustive-deps */
import { useTheme } from "@emotion/react";
import { Box, Button, CircularProgress, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Popup from "../../components/popups/popup";
import CustomInput from "../../components/inputs/customInput";
import AddIcon from '@mui/icons-material/Add';
import UserDropdown from "../../components/dropdowns/userDropdown";
import ReciverDropdown from "../../components/dropdowns/reciverDropdown";
import PageDropdown from "../../components/dropdowns/pageDropdown";
import DriverDropdown from "../../components/dropdowns/driverDropdown";
import WhatsAppMsgService from "../../services/whatsAppMsgService";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const AddWhatsAppMsg = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [selectedReciver, setSelectedReciver] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedPage, setSelectedPage] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);

    const [formValues, setFormValues] = useState({
        reciver: '',
        reciverIds: null,
        content: '',
    });

    const [addErrors, setAddErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newAddErrors = {};

        if (!formValues.reciver) newAddErrors.reciver = t('reciverRequired');
        if (!formValues.content) newAddErrors.titleKurdish = t('contentRequired');


        setAddErrors(newAddErrors);

        return Object.keys(newAddErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm()) {
            try {
                setIsLoading(true);
                const reciverIds = selectedIds.length === 0 ? undefined :
                    selectedIds.map((id) => id.id);

                const data = await WhatsAppMsgService.add({
                    ...formValues,
                    reciverIds
                });

                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('success');
                    setShowPopup(true);
                    setFormValues({
                        reciver: '',
                        reciverId: null,
                        content: '',
                        titleEnglish: '',
                        titleArabic: '',
                        descriptionKurdish: '',
                        descriptionEnglish: '',
                        descriptionArabic: ''
                    });
                    setSelectedReciver(null);
                    setSelectedUser(null);
                    setSelectedDriver(null);
                    setSelectedPage(null);
                }

                setAddErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setAddErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setAddErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    const personDropdown = () => {
        if (selectedReciver === t('page')) {
            return (
                <PageDropdown
                    helperText={addErrors.page}
                    error={!!addErrors.page}
                    isFilter={false}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                />
            );
        } else if (selectedReciver === t('user')) {
            return (
                <UserDropdown
                    helperText={addErrors.user}
                    error={!!addErrors.user}
                    isFilter={false}
                    selectedUser={selectedUser}
                    setSelectedUser={setSelectedUser}
                />
            );
        } else if (selectedReciver === t('driver')) {
            return (
                <DriverDropdown
                    helperText={addErrors.driver}
                    error={!!addErrors.driver}
                    isFilter={false}
                    selectedDriver={selectedDriver}
                    setSelectedDriver={setSelectedDriver}
                />
            );
        }
    };

    const personNoteText = () => {
        if (selectedReciver === t('user'))
            return t('selectReciverNoteUser');
        else if (selectedReciver === t('page'))
            return t('selectReciverNotePage');
        else if (selectedReciver === t('driver'))
            return t('selectReciverNoteDriver');

    };

    const handleRemoveId = (indexToRemove) => {
        const updatedNumbers = selectedIds.filter((_, index) => index !== indexToRemove);
        setSelectedIds(updatedNumbers);
    };

    useEffect(() => {
        setSelectedIds([]);
    }, [selectedReciver]);

    useEffect(() => {
        let selectedObj;
        if (selectedReciver === t('user'))
            selectedObj = selectedUser;
        else if (selectedReciver === t('page'))
            selectedObj = selectedPage;
        else if (selectedReciver === t('driver'))
            selectedObj = selectedDriver;

        if (selectedObj) {
            setSelectedIds((prevSelectedIds) => {
                const isDuplicate = prevSelectedIds.some(item => item.id === selectedObj.id);
                if (!isDuplicate) {
                    return [...prevSelectedIds, { id: selectedObj.id, name: selectedObj.name }];
                }
                return prevSelectedIds;
            });
        }
    }, [selectedPage, selectedDriver, selectedUser]);

    return (
        <Box sx={{
            p: isTablet ? 1 : 2,
            backgroundColor: theme.palette.secondary.main,
        }}>

            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    p: isTablet ? 2 : 4
                }}
            >

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Typography id="transition-modal-title" variant="h6" component="h2">
                        {t('addWhatsAppMsg')}
                    </Typography>
                </Box>

                {/* dropdowns */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    {/* reciver */}
                    <Box width={isTablet ? '100%' : '32%'}>
                        <ReciverDropdown
                            helperText={addErrors.reciver}
                            error={!!addErrors.reciver}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedReciver={selectedReciver}
                            setSelectedReciver={setSelectedReciver}
                        />
                    </Box>


                    {/* person */}
                    <Box width={isTablet ? '100%' : '32%'}>
                        {personDropdown()}
                    </Box>

                    {/* note */}
                    <Box width={isTablet ? '100%' : '32%'} mt={isTablet ? 1 : 4}>
                        <Typography id="transition-modal-title" variant="subtitle1" component="h2">
                            {personNoteText()}
                        </Typography>
                    </Box>
                </Box>

                {
                    selectedIds.length !== 0 &&
                    <Box
                        sx={{
                            width: '100%',
                            mt: isTablet ? 2 : 4,
                            py: isTablet ? 1 : 2,
                            px: isTablet ? 0 : 1,
                            border: 1,
                            backgroundColor: theme.palette.customGrey.insideInput,
                            borderColor: theme.palette.customGrey.borderInput,
                            borderRadius: 1
                        }}>
                        {selectedIds.map((item, index) => (
                            <Box
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    px: 1.2,
                                }} key={index}
                            >
                                <Typography variant="subtitle2">{item.name}</Typography>
                                <CloseOutlinedIcon
                                    sx={{
                                        color: theme.palette.text.red,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handleRemoveId(index)}
                                />

                            </Box>
                        ))}
                    </Box>
                }


                {/* content */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '32%'}>
                        <CustomInput
                            label={t('content')}
                            placeholder={t('contentHere')}
                            name="content"
                            type='text'
                            value={formValues.content}
                            error={!!addErrors.content}
                            helperText={addErrors.content}
                            onChange={handleChange}
                        />
                    </Box>

                </Box>

                {addErrors.general && (
                    <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                        {addErrors.general}
                    </Typography>
                )}

                <Box sx={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    mt: addErrors.general ? 2 : 4
                }}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ textTransform: 'none', width: 140, height: 40 }}
                    >
                        {isLoading ? <CircularProgress color="secondary" size={28} /> :
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('add')}</p>
                                <AddIcon fontSize="small" sx={{ mx: 0.4 }} />
                            </Box>
                        }
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default AddWhatsAppMsg;